import { useContext, useMemo } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import SpmConstants from 'sg-spm-constants';
import SpmUtils from 'sg-spm-utils';
import metadata from './SgMotorSelectChanges.metadata.json5';
import messages from '../SgEndorsementInfo.messages';

function SgMotorSelectChanges(props) {
    const {
        policyDetails,
        handleChangeSelect,
    } = props;

    const translator = useContext(TranslatorContext);

    const vehicle = useMemo(() => {
        return policyDetails.policyLineInfo.privateMotor.vehicleDTO;
    }, [policyDetails]);

    const drivers = useMemo(() => {
        return policyDetails.policyLineInfo.privateMotor.driverDTOs;
    }, [policyDetails]);

    const voluntaryADExcess = useMemo(() => {
        const basicCov = _.find(vehicle.coverages, (cov) => cov.name === SpmConstants.BASIC_MOTOR_COVER_NAME);
        return _.find(basicCov.terms, (term) => term.name === SpmConstants.VOLUNTARY_AD_EXCESS_NAME);
    }, [vehicle]);

    const isSagaPlus = useMemo(() => {
        return SpmUtils.isSagaPlus(policyDetails);
    }, [policyDetails]);

    const selectedCoverages = useMemo(() => {
        return _.filter(vehicle.coverages, (cov) => cov.name !== SpmConstants.BASIC_MOTOR_COVER_NAME
            && cov.name !== SpmConstants.ACCIDENT_HEALTHCARE_NAME);
    }, [vehicle]);

    const overrides = {
        vehicleInfoValue: {
            content: `${vehicle.make} ${vehicle.model} ${vehicle.registrationNumber}`
        },
        vehicleMileageValue: {
            content: vehicle.mileageRange
        },
        vehicleUseValue: {
            content: translator({ id: `typekey.VehicleUse_Ext.${vehicle.vehicleUse}`, defaultMessage: '' })
        },
        vehicleParkingValue: {
            content: translator({ id: `typekey.VehicleParkingType_Ext.${vehicle.vehicleParkingType}`, defaultMessage: '' })
        },
        vehicleModificationsValue: {
            content: _.isEmpty(vehicle.modifications) ? translator(messages.VehicleNoModificationsValue) : vehicle.modifications.join(', ')
        },
        changeVehicleCheckbox: {
            value: policyDetails.lobData.privateMotor.selectedChanges.hasVehicleChanges,
            onValueChange: (value) => handleChangeSelect(value, 'hasVehicleChanges')
        },
        driversList: {
            data: drivers
        },
        changeDriversCheckbox: {
            value: policyDetails.lobData.privateMotor.selectedChanges.hasDriverChanges,
            onValueChange: (value) => handleChangeSelect(value, 'hasDriverChanges')
        },
        voluntaryADExcess: {
            visible: !_.isEmpty(voluntaryADExcess)
        },
        voluntaryADExcessValue: {
            content: !_.isEmpty(voluntaryADExcess) ? voluntaryADExcess.deductible : ''
        },
        selectedCoveragesContainer: {
            visible: !_.isEmpty(selectedCoverages)
        },
        selectedCoveragesList: {
            data: selectedCoverages,
            className: isSagaPlus ? 'sg-endorsement-policy-info-coverages sg-endorsement-claims-promise' : 'sg-endorsement-policy-info-coverages'
        },
        claimsPromiseCoverage: {
            visible: isSagaPlus
        },
        notSelectedCoveragesContainer: {
            visible: !_.isEmpty(policyDetails.policyLineInfo.privateMotor.notSelectedCoverages)
        },
        notSelectedCoveragesList: {
            data: policyDetails.policyLineInfo.privateMotor.notSelectedCoverages
        },
        changeCoveragesCheckbox: {
            value: policyDetails.lobData.privateMotor.selectedChanges.hasCoveragesChanges,
            onValueChange: (value) => handleChangeSelect(value, 'hasCoveragesChanges')
        }
    };
    const resolvers = {
        resolveComponentMap: {
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

export default SgMotorSelectChanges;
